export const  urlServer ='localhost';
export const REACT_APP_YOUTUBE_API_KEY='AIzaSyAM7h3IoQgOg8sHN6tJWq2Dfuwsv5ayzq4';

